import React, { Component } from "react";

export const login = (token, name) => {
  localStorage.setItem("token", token);
  localStorage.setItem("userName", name);
};

export const logout = (props) => {
  window.localStorage.removeItem("token");
  window.location.href = "/login";
  localStorage.removeItem("userName");
  localStorage.removeItem("userId");
  localStorage.removeItem("realTimeGroupId");
  localStorage.removeItem("realTimeGroupName");
};

function authenticateFactory(ComposedComponent) {
  class Authenticate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isAuthenticated: false,
      };
    }
    componentDidMount() {
      this._checkAndRedirect();
    }

    _checkAndRedirect() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.setState({ isAuthenticated: false });
        this.props.history.push("/login");
      } else {
        this.setState({ isAuthenticated: true });
      }
    }

    render() {
      return (
        <div>
          {this.state.isAuthenticated ? (
            <ComposedComponent {...this.props} />
          ) : null}
        </div>
      );
    }
  }

  return Authenticate;
}

export default authenticateFactory;
